// extracted by mini-css-extract-plugin
module.exports = {"button":"common-button__button","button--arrow":"common-button__button--arrow","button--medium":"common-button__button--medium","button--outline":"common-button__button--outline"};